var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCancel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3637 28.934q1.0467 1.271 0 2.5419-1.2709 1.0467-2.5419 0L20 22.5793l-8.8967 8.8966q-1.271 1.0467-2.5419 0-1.0467-1.271 0-2.5419l8.8966-8.8966-8.8966-8.9714q-1.0467-1.271 0-2.542 1.271-1.0466 2.5419 0L20 17.4955l8.8966-8.8966q1.271-1.0465 2.5419 0 1.0467 1.271 0 2.5419l-8.8966 8.8967z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCancel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cancel.ed04557c185fd7e021e8814db0f0fe79.svg";